export default {
  // Expenses
  'finance.expenses.headerTitle': 'Financial Expense Management',
  'finance.expenses.action.create': 'New Financial Expense',
  'finance.expenses.action.submitAudit': 'Submit for Audit',
  'finance.expenses.confirm.delete':
    'Are you sure you want to delete this financial expense?',
  'finance.expenses.confirm.submitTitle': 'Confirm Submission',
  'finance.expenses.confirm.submitContent':
    'Are you sure you want to submit this financial report?',
  'finance.expenses.confirm.submitOk': 'Confirm Submit',
  'finance.expenses.confirm.submitSummaryHint':
    'Please review the submission details before confirming.',
  'finance.expenses.confirm.category': 'Expense Category',
  'finance.expenses.confirm.amountType': 'Direction',
  'finance.expenses.confirm.totalAmount': 'Total Amount',
  'finance.expenses.confirm.expenseType': 'Expense Type',
  'finance.expenses.confirm.bankStatement': 'Bank Statement',
  'finance.expenses.confirm.routeTitle': 'Choose Submission Route',
  'finance.expenses.confirm.routeHint':
    'Choose the financial step to enter after submission',
  'finance.expenses.confirm.pricingTitle': 'Enter Financial Pricing',
  'finance.expenses.confirm.pricingDescription':
    'Finance will verify the amount first, then send it to financial audit after pricing is approved.',
  'finance.expenses.confirm.auditTitle': 'Go Directly to Financial Audit',
  'finance.expenses.confirm.auditDescription':
    'Skip financial pricing and send the report directly to the financial audit queue.',
  'finance.expenses.confirm.defaultRoute': 'Default Route',
  'finance.expenses.confirm.directRoute': 'Quick Submit',
  'finance.expenses.confirm.batchDelete':
    'Are you sure you want to batch delete selected financial expenses?',
  'finance.expenses.confirm.batchDeleteDesc':
    'This will delete {count} selected financial expenses, and this action cannot be undone.',
  'finance.expenses.action.batchRevertAudit': 'Batch Revert Audit',
  'finance.expenses.confirm.batchRevertAudit':
    'Are you sure you want to batch revert the selected approved financial expenses?',
  'finance.expenses.confirm.batchRevertAuditDesc':
    'This will revert {count} selected approved financial expenses back to pending status.',
  'finance.expenses.message.batchRevertAudit.success':
    'Batch revert audit successful',
  'finance.expenses.message.batchRevertAudit.failed':
    'Batch revert audit failed',
  'finance.expenses.message.batchRevertAudit.noCode':
    'Selected records are missing codes and cannot be reverted',
  'finance.expenses.message.getDetailFailed':
    'Failed to get financial expense details',
  'finance.expenses.message.generateCodeFailed': 'Failed to generate code',
  'finance.expenses.message.update.success':
    'Financial expense updated successfully',
  'finance.expenses.message.update.failed':
    'Failed to update financial expense',
  'finance.expenses.message.create.success':
    'Financial expense created successfully',
  'finance.expenses.message.create.failed':
    'Failed to create financial expense',
  'finance.expenses.error.loadTypeDict':
    'Failed to load expense type dictionary',
  'finance.expenses.message.selectForAudit':
    'Please select financial expenses to submit for audit',
  'finance.expenses.audit.defaultName':
    'Financial Expense Audit ({count} items)',
  'finance.expenses.message.submitAudit.success':
    'Submitted for audit successfully',
  'finance.expenses.message.submitAudit.failed': 'Failed to submit for audit',
  'finance.expenses.column.code': 'Code',
  'finance.expenses.column.name': 'Expense Name',
  'finance.expenses.column.type': 'Expense Type',
  'finance.expenses.column.expenseTypeCategory': 'Expense Type',
  'finance.expenses.column.projectName': 'Project Name',
  'finance.expenses.column.relatedProject': 'Related Project',
  'finance.expenses.column.bankStatement': 'Bank Statement',
  'finance.expenses.column.expenseDate': 'Expense Date',
  'finance.expenses.column.checkNo': 'Check No.',
  'finance.expenses.column.amount': 'Amount',
  'finance.expenses.column.payableAmount': 'Payable',
  'finance.expenses.column.paidAmount': 'Paid',
  'finance.expenses.column.receivableAmount': 'Receivable',
  'finance.expenses.column.receivedAmount': 'Received',
  'finance.expenses.column.houseNo': 'House Number',
  'finance.expenses.column.parkingNo': 'Parking Number',
  'finance.expenses.column.dateRange': 'Date Range',
  'finance.expenses.column.status': 'Status',
  'finance.expenses.column.applyReason': 'Application Reason',
  'finance.pricing_review.column.applyReason': 'Application Reason',
  'finance.expenses.column.remarks': 'Remarks',
  'finance.expenses.status.draft': 'Draft',
  'finance.expenses.status.pending': 'Pending',
  'finance.expenses.status.approved': 'Approved',
  'finance.expenses.status.rejected': 'Rejected',
  'finance.finReporting.tab.apply': 'Financial Audit',
  'finance.finReporting.tab.approved': 'Approved',
  'finance.finReporting.tab.rejected': 'Rejected',
  'finance.finReporting.config.button': 'Configure',
  'finance.finReporting.config.title':
    'Financial Reporting Department Configuration',
  'finance.finReporting.config.office':
    'Departments allowed to skip financial pricing',
  'finance.finReporting.config.officePlaceholder':
    'Select departments; multiple allowed',
  'finance.finReporting.config.loadFailed': 'Failed to load configuration',
  'finance.finReporting.config.saveSuccess': 'Configuration saved',
  'finance.finReporting.config.saveFailed': 'Failed to save configuration',
  'finance.engApply.tab.pricing': 'Pricing Review',
  'finance.engApply.tab.apply': 'Under Review',
  'finance.engApply.tab.approved': 'Approved',
  'finance.engApply.tab.rejected': 'Rejected',
  'finance.engApply.pendingCount.label': 'Pending',
  'finance.engApply.pendingCount.empty': 'No pending applications',
  'finance.engApply.pendingCount.more': '+{count} projects',
  'finance.engApply.pendingDrawer.title': '{project} pending applications',
  'finance.engApply.status.pricing': 'Pending Pricing',
  'finance.expenses.modal.detailTitle': 'Financial Expense Details',
  'finance.expenses.label.code': 'Code',
  'finance.expenses.label.name': 'Expense Name',
  'finance.expenses.label.type': 'Expense Type',
  'finance.expenses.label.amount': 'Amount',
  'finance.expenses.label.status': 'Status',
  'finance.expenses.label.applicantBy': 'Submitter',
  'finance.expenses.label.applyUser': 'Applicant',
  'finance.expenses.label.payeeUser': 'Payee',
  'finance.expenses.label.projectName': 'Project Name',
  'finance.expenses.label.applyReason': 'Application Reason',
  'finance.expenses.label.auditBy': 'Auditor ID',
  'finance.expenses.label.auditReason': 'Audit Note',
  'finance.expenses.label.relatedFile': 'Related Files',
  'finance.expenses.label.remarks': 'Remarks',
  'finance.expenses.label.baseAmount': 'Expense Amount',
  'finance.expenses.label.ewtAmount': 'EWT Amount',
  'finance.expenses.label.ctoAmount': 'CTO Tax Amount',
  'finance.expenses.label.checkAmount': 'Check Amount',
  'finance.expenses.label.checkNo': 'Check Number',
  'finance.expenses.label.writeOffAmount': 'Write-off Amount',
  'finance.expenses.label.amountType': 'Amount Type',
  'finance.expenses.label.paymentAmount': 'Payment Amount',
  'finance.expenses.label.inputTax': 'INPUT TAX',
  'finance.expenses.label.outputTax': 'OUTPUT TAX',
  'finance.expenses.label.receiptAttachment': 'Receipt Attachment',
  'finance.expenses.placeholder.paymentAmount': 'Please enter payment amount',
  'finance.expenses.placeholder.ewtAmount': 'Please enter EWT amount',
  'finance.expenses.placeholder.ctoAmount': 'Please enter CTO tax amount',
  'finance.expenses.placeholder.inputTax': 'Please enter INPUT TAX',
  'finance.expenses.placeholder.outputTax': 'Please enter OUTPUT TAX',
  'finance.expenses.placeholder.checkNo': 'Please enter check number',
  'finance.expenses.rule.paymentAmountRequired': 'Please enter payment amount',
  'finance.expenses.section.amountDetail': 'Amount Details',
  'finance.expenses.form.expenseName.label': 'Expense Name',
  'finance.expenses.form.expenseName.placeholder':
    'Example: Feb 2026 property elevator routine maintenance fee',
  'finance.expenses.form.expenseName.required': 'Please enter name',
  'finance.expenses.form.expenseName.max': 'Name cannot exceed 100 characters',
  'finance.expenses.form.payee.label': 'Payee',
  'finance.expenses.form.payee.placeholder': 'Please enter payee',
  'finance.expenses.form.detailDescription.label': 'Detailed Description',
  'finance.expenses.form.detailDescription.placeholder':
    'Please enter detailed description here...',
  'finance.expenses.form.detailDescription.max':
    'Application reason cannot exceed 500 characters',
  'finance.expenses.form.remarkInfo.label': 'Remark Information',
  'finance.expenses.form.remarkInfo.placeholder':
    'Please enter remark information',
  'finance.expenses.form.remarkInfo.max':
    'Remarks cannot exceed 500 characters',
  'finance.expenses.action.uploading': 'Uploading...',
  'finance.expenses.action.uploadAttachment': 'Upload Attachment',
  'finance.expenses.action.viewFile': 'View File',
  'finance.expenses.action.delete': 'Delete',
  'finance.expenses.label.uploadUser': 'Uploaded By',
  'finance.expenses.label.uploadTime': 'Upload Time',
  'finance.expenses.label.fileSize': 'File Size',
  'finance.expenses.upload.supportTip':
    'Supports PDF, Word, Excel, image, and video formats. Each file must be under 200MB',
  'finance.expenses.message.uploadTypeLimit':
    'Only PDF, Word, Excel, TXT, image, or video files are allowed!',
  'finance.expenses.message.uploadSizeLimit': 'File size cannot exceed 200MB!',
  'finance.expenses.type.other': 'Other',
  'finance.expenses.tax.ewt': 'EWT',
  'finance.expenses.tax.cto': 'CTO',
  'finance.expenses.tax.inputTax': 'INPUT TAX',
  'finance.expenses.tax.outputTax': 'OUTPUT TAX',
  'finance.expenses.section.auditRecords': 'Audit Records',
  'finance.expenses.loading': 'Loading...',
  'finance.expenses.empty.auditRecords': 'No audit records',
  'finance.expenses.empty.relatedFile': 'No related files',
  'finance.expenses.action.addAttachment': 'Add Attachment',
  'finance.expenses.modal.addAttachmentTitle': 'Add Attachment',
  'finance.expenses.message.uploadSuccess': 'File uploaded successfully',
  'finance.expenses.message.uploadFailed': 'File upload failed',
  'finance.expenses.message.attachmentRequired':
    'Please upload an attachment first',
  'finance.expenses.message.attachmentAdded': 'Attachment added successfully',
  'finance.expenses.message.attachmentAddFailed': 'Failed to add attachment',
  'finance.expenses.modal.submitAuditTitle': 'Submit for Audit',
  'finance.expenses.drawer.title.edit': 'Edit Financial Expense',
  'finance.expenses.drawer.title.create': 'New Financial Expense',
  'finance.expenses.form.auditName.label': 'Audit Name',
  'finance.expenses.form.auditName.placeholder': 'Please enter audit name',
  'finance.expenses.form.auditName.required': 'Please enter audit name',
  'finance.expenses.form.submitRemark.label': 'Submission Note',
  'finance.expenses.form.submitRemark.placeholder':
    'Please enter submission note (optional)',
  'finance.expenses.selectedBills':
    'Selected financial expense list ({count} items total)',
  'finance.expenses.form.code.label': 'Code',
  'finance.expenses.form.code.placeholder': 'Please enter code',
  'finance.expenses.form.code.required': 'Please enter code',
  'finance.expenses.form.code.max': 'Code cannot exceed 100 characters',
  'finance.expenses.form.name.label': 'Expense Name',
  'finance.expenses.form.name.placeholder': 'Please enter expense name',
  'finance.expenses.form.name.required': 'Expense name is required',
  'finance.expenses.form.name.max': 'Expense name cannot exceed 100 characters',
  'finance.expenses.form.type.label': 'Expense Type',
  'finance.expenses.form.type.placeholder': 'Please select expense type',
  'finance.expenses.form.type.required': 'Please select expense type',
  'finance.expenses.form.amount.label': 'Amount',
  'finance.expenses.form.amount.placeholder': 'Please enter amount',
  'finance.expenses.form.amount.required': 'Please enter amount',
  'finance.expenses.form.amount.min': 'Amount cannot be less than 0',
  'finance.expenses.form.bankStatement.label': 'Bank Statement',
  'finance.expenses.form.bankStatement.placeholder':
    'Search and select a bank statement',
  'finance.expenses.form.projectName.label': 'Project Name',
  'finance.expenses.form.projectName.placeholder': 'Please select project name',
  'finance.expenses.form.applyUser.label': 'Applicant',
  'finance.expenses.form.applyUser.placeholder': 'Please enter applicant',
  'finance.expenses.form.applyUser.max':
    'Applicant cannot exceed 100 characters',
  'finance.expenses.form.payeeUser.label': 'Payee',
  'finance.expenses.form.payeeUser.placeholder': 'Please enter payee',
  'finance.expenses.form.payeeUser.max': 'Payee cannot exceed 100 characters',
  'finance.expenses.form.applyReason.label': 'Application Reason',
  'finance.expenses.form.applyReason.placeholder':
    'Please enter application reason',
  'finance.expenses.form.applyReason.max':
    'Application reason cannot exceed 500 characters',
  'finance.expenses.form.remarks.label': 'Remarks',
  'finance.expenses.form.remarks.placeholder': 'Please enter remarks',
  'finance.expenses.form.remarks.max': 'Remarks cannot exceed 500 characters',
  'finance.expenses.placeholder.startDate': 'Start date',
  'finance.expenses.placeholder.endDate': 'End date',
  'finance.expenses.category.dailyExpense': 'Daily Expense',
  'finance.expenses.category.realEstate': 'Real Estate',
  'finance.expenses.category.propertyFee': 'Property Fee',
  'finance.expenses.drawer.title.editExpense': 'Edit Expense',
  'finance.expenses.drawer.title.createExpense': 'Create Expense',
  'finance.expenses.board.title': 'Expense Entry Board',
  'finance.expenses.board.category': 'Expense Category',
  'finance.expenses.amountType.in': 'Income',
  'finance.expenses.amountType.out': 'Expense',
  'finance.expenses.label.businessDate': 'Business Date',
  'finance.expenses.section.relatedLocation': 'Related Location Info',
  'finance.expenses.label.relatedProject': 'Related Project',
  'finance.expenses.label.expenseType': 'Expense Type',
  'finance.expenses.placeholder.relatedProject':
    'Please select related project',
  'finance.expenses.placeholder.expenseType': 'Please select expense type',
  'finance.expenses.section.coreDetail': 'Core Expense Details',
  'finance.expenses.section.attachmentRemark': 'Attachments and Remarks',
  'finance.expenses.section.basic': 'Basic Information',
  'finance.expenses.section.apply': 'Application Information',
  'finance.expenses.section.relatedFile': 'Related Files',
  'finance.expenses.section.other': 'Other Information',
  'finance.expenses.section.bankStatement': 'Related Bank Statement',
  'finance.expenses.tab.all': 'All Data',
  'finance.expenses.tab.byTime': 'Search by Date',
  'finance.expenses.tab.byHouse': 'Search by House No.',
  'finance.expenses.tab.byParking': 'Search by Parking No.',
  'finance.expenses.action.import': 'Import Detail Data',
  'finance.expenses.import.section.category': 'Expense Category',
  'finance.expenses.import.section.assetType': 'Asset Type',
  'finance.expenses.import.section.actions': 'Import Actions',
  'finance.expenses.import.section.history': 'Import History',
  'finance.expenses.import.section.detail': 'Import Details',
  'finance.expenses.import.category.daily': 'Daily Expense',
  'finance.expenses.import.category.realEstate': 'Real Estate Detail',
  'finance.expenses.import.category.propertyFee': 'Property Fee Detail',
  'finance.expenses.import.template.realEstateHouse':
    'Real Estate Detail - House',
  'finance.expenses.import.template.realEstateParking':
    'Real Estate Detail - Parking',
  'finance.expenses.import.template.propertyFeeHouse':
    'Property Fee Detail - House',
  'finance.expenses.import.template.propertyFeeParking':
    'Property Fee Detail - Parking',
  'finance.expenses.import.assetType.house': 'House',
  'finance.expenses.import.assetType.parking': 'Parking',
  'finance.expenses.import.action.importExcel': 'Import Excel',
  'finance.expenses.import.action.downloadTemplate': 'Download {name} Template',
  'finance.expenses.import.action.importAll': 'Import All',
  'finance.expenses.import.action.exportExcel': 'Export Excel',
  'finance.expenses.import.action.prevPage': 'Previous',
  'finance.expenses.import.action.nextPage': 'Next',
  'finance.expenses.import.status.pending': 'Pending Import',
  'finance.expenses.import.status.success': 'Import Success',
  'finance.expenses.import.status.failed': 'Import Failed',
  'finance.expenses.import.stats.total': 'Total',
  'finance.expenses.import.stats.success': 'Success',
  'finance.expenses.import.stats.pending': 'Pending',
  'finance.expenses.import.stats.failed': 'Failed',
  'finance.expenses.import.pagination.simple': 'Total {total} · Page {page}',
  'finance.expenses.import.unnamedFile': 'Unnamed File',
  'finance.expenses.import.column.date': 'Date',
  'finance.expenses.import.column.relatedProject': 'Related Project',
  'finance.expenses.import.column.expenseType': 'Expense Type',
  'finance.expenses.import.column.houseInfo': 'House Information',
  'finance.expenses.import.column.parkingInfo': 'Parking Information',
  'finance.expenses.import.edit.title': 'Edit Import Data',
  'finance.expenses.import.edit.success': 'Updated successfully',
  'finance.expenses.import.edit.failed': 'Update failed',
  'finance.expenses.import.edit.copyEmpty': 'Please select a value first',
  'finance.expenses.import.edit.copySuccess': 'Copied: {text}',
  'finance.expenses.import.edit.copyFailed': 'Copy failed',
  'finance.expenses.import.column.amount': 'Amount',
  'finance.expenses.import.column.error': 'Error',
  'finance.expenses.import.label.dataStatus': 'Data Status',
  'finance.expenses.import.label.building': 'Building',
  'finance.expenses.import.label.floor': 'Floor',
  'finance.expenses.import.label.roomNumber': 'Room Number',
  'finance.expenses.import.label.income': 'Income',
  'finance.expenses.import.label.expense': 'Expense',
  'finance.expenses.import.label.checkAmount': 'Check Amount',
  'finance.expenses.import.label.checkNo': 'Check No.',
  'finance.expenses.import.label.bankStatement': 'Bank Statement',
  'finance.expenses.import.empty.selectRecord':
    'Select an import record from the left to view details',
  'finance.expenses.import.modal.detailTitle': 'Import Data Detail',
  'finance.expenses.import.modal.errorDetailTitle': 'Error Details',
  'finance.expenses.import.message.templateDownloadSuccess':
    'Template downloaded successfully',
  'finance.expenses.import.message.uploading': 'Uploading file...',
  'finance.expenses.import.message.uploadSuccess': 'File uploaded successfully',
  'finance.expenses.import.message.uploadFailed': 'File upload failed',
  'finance.expenses.import.message.uploadFailedRetry':
    'File upload failed, please try again',
  'finance.expenses.import.message.unknownCategory': 'Unknown category type',
  'finance.expenses.import.message.selectRecordFirst':
    'Please select an import record first',
  'finance.expenses.import.message.exporting': 'Exporting data...',
  'finance.expenses.import.message.exportSuccess': 'Data exported successfully',
  'finance.expenses.import.message.exportFailed': 'Data export failed',
  'finance.expenses.import.message.exportFailedRetry':
    'Data export failed, please try again',
  'finance.expenses.import.message.importing': 'Importing data...',
  'finance.expenses.import.message.importStarted':
    'Data import has started, please check later',
  'finance.expenses.import.message.importFailed': 'Data import failed',
  'finance.expenses.import.message.importFailedRetry':
    'Data import failed, please try again',
  'finance.expenses.action.createDetail': 'Create Expense Detail',
  'finance.expenses.action.financialDeclare': 'Financial Declaration',
  'finance.expenses.action.exportExcel': 'Export Excel',
  'finance.expenses.action.configShort': 'Config',
  'finance.expenses.summary.currentPage': 'Current Page Summary',
  'finance.expenses.summary.allPages': 'All Pages Summary',
  'finance.expenses.message.bankStatementNotFound':
    'Failed to load bank statement information',
  'finance.expenses.action.upload': 'Click to upload related files',
  'finance.expenses.action.downloadOriginal': 'Download original file',

  // Mortgage Pay
  'finance.mortgagePay.headerTitle': 'Mortgage Repayment Management',
  'finance.mortgagePay.tab.mortgage': 'Mortgage Repayment',
  'finance.mortgagePay.tab.car': 'Parking Space Repayment',
  'finance.mortgagePay.action.create': 'New Repayment',
  'finance.mortgagePay.action.exportExcel': 'Export Excel',
  'finance.mortgagePay.action.batchCreate': 'Batch Repayment',
  'finance.mortgagePay.action.resetDueDate': 'Reset Due Date',
  'finance.mortgagePay.modal.resetDueDateTitle': 'Reset Due Date',
  'finance.mortgagePay.message.resetDueDate.submitted':
    'The request has been submitted successfully. Please check the result later.',
  'finance.mortgagePay.message.resetDueDate.failed': 'Failed to reset due date',
  'finance.mortgagePay.resetDueDate.description.title': 'Description:',
  'finance.mortgagePay.resetDueDate.description.content':
    'Reset the due date based on the repayment day configured for the house or parking space. If no house/parking is selected, all records will be reset. This is an async task; please check the result later after submission.',
  'finance.mortgagePay.action.upload': 'Click to upload attachment',
  'finance.mortgagePay.action.downloadOriginal': 'Download original file',
  'finance.mortgagePay.action.searchHouse': 'Search',
  'finance.mortgagePay.column.billingPeriod': 'Billing Period',
  'finance.mortgagePay.column.type': 'Type',
  'finance.mortgagePay.column.code': 'Repayment Code',
  'finance.mortgagePay.column.houseInfo': 'House Information',
  'finance.mortgagePay.column.repaymentHistory': 'Repayment History',
  'finance.mortgagePay.column.projectName': 'Project Name',
  'finance.mortgagePay.column.bank': 'Bank',
  'finance.common.column.bankTransaction': 'Bank Transaction',
  'finance.common.bankTransaction.matched': 'Matched',
  'finance.common.bankTransaction.matchedWithCount': 'Matched ({count})',
  'finance.common.bankTransaction.partialMatchedWithCount':
    'Partially Matched ({count})',
  'finance.common.bankTransaction.unmatched': 'Unmatched',
  'finance.common.bankTransaction.detailTitle': 'Bank Transaction Details',
  'finance.common.bankTransaction.noData': 'No bank transaction data',
  'finance.common.bankTransaction.itemTitle': 'Transaction {index}',
  'finance.common.bankTransaction.section.bankStatement':
    'Related Bank Statement',
  'finance.common.bankTransaction.section.transaction': 'Transaction Details',
  'finance.common.bankTransaction.matchType': 'Match Type',
  'finance.common.bankTransaction.matchType.auto': 'Auto',
  'finance.common.bankTransaction.matchType.manual': 'Manual',
  'finance.common.bankTransaction.assetCode': 'Related Code',
  'financeReconciliation.match.matchedAmount': 'Matched Amount',
  'financeReconciliation.match.finalAmount': 'Final Amount',
  'financeReconciliation.match.finalAmountPending': 'Final Amount (Check)',
  'finance.mortgagePay.column.amount': 'Due Amount',
  'finance.mortgagePay.column.receiptAmount': 'Actual Amount',
  'finance.mortgagePay.column.repaymentAmount': 'Repayment Amount',
  'finance.mortgagePay.column.dueAmount': 'Due',
  'finance.mortgagePay.column.actualAmount': 'Paid',
  'finance.mortgagePay.column.repaymentTime': 'Repayment Time',
  'finance.mortgagePay.column.dueDate': 'Due',
  'finance.mortgagePay.column.receiptDate': 'Paid',
  'finance.mortgagePay.column.status': 'Status',
  'finance.mortgagePay.column.remarks': 'Remarks',
  'finance.mortgagePay.type.rent': 'Rent',
  'finance.mortgagePay.type.mortgage': 'Mortgage',
  'finance.mortgagePay.status.draft': 'Draft',
  'finance.mortgagePay.status.pending': 'Pending',
  'finance.mortgagePay.status.approved': 'Approved',
  'finance.mortgagePay.status.rejected': 'Rejected',
  'finance.mortgagePay.status.overdue': 'Overdue',
  'finance.mortgagePay.modal.detailTitle': 'Mortgage Repayment Details',
  'finance.mortgagePay.modal.batchCreateTitle':
    'Batch Create Repayment Records',
  'finance.mortgagePay.label.code': 'Repayment Code',
  'finance.mortgagePay.label.billingPeriod': 'Billing Period',
  'finance.mortgagePay.label.type': 'Type',
  'finance.mortgagePay.label.amount': 'Repayment Amount',
  'finance.mortgagePay.label.bank': 'Bank',
  'finance.mortgagePay.label.status': 'Status',
  'finance.mortgagePay.label.houseInfo': 'House Information',
  'finance.mortgagePay.label.ownerInfo': 'Owner Information',
  'finance.mortgagePay.label.email': 'Email',
  'finance.mortgagePay.label.ownerId': 'Owner ID',
  'finance.mortgagePay.label.attachment': 'Attachment',
  'finance.mortgagePay.label.remarks': 'Remarks',
  'finance.mortgagePay.label.projectName': 'Project Name',
  'finance.mortgagePay.section.houseOwner': 'House and Owner Information',
  'finance.mortgagePay.section.attachment': 'Attachment',
  'finance.mortgagePay.section.basic': 'Basic Information',
  'finance.mortgagePay.section.other': 'Other Information',
  'finance.mortgagePay.section.auditRecords': 'Audit Records',
  'finance.mortgagePay.section.bankStatement': 'Related Bank Statement',
  'finance.mortgagePay.drawer.title.edit': 'Edit Mortgage Repayment',
  'finance.mortgagePay.drawer.title.create': 'New Mortgage Repayment',
  'finance.mortgagePay.form.code.label': 'Repayment Code',
  'finance.mortgagePay.form.code.placeholder': 'Please enter repayment code',
  'finance.mortgagePay.form.code.required': 'Please enter repayment code',
  'finance.mortgagePay.form.code.max':
    'Code length cannot exceed 100 characters',
  'finance.mortgagePay.form.billingPeriod.label': 'Billing Period',
  'finance.mortgagePay.form.billingPeriod.placeholder':
    'Please select billing period',
  'finance.mortgagePay.form.billingPeriod.required':
    'Please select billing period',
  'finance.mortgagePay.form.house.label': 'House',
  'finance.mortgagePay.form.house.placeholder': 'Please select house',
  'finance.mortgagePay.form.house.required': 'Please select house',
  'finance.mortgagePay.form.parking.placeholder': 'Please select parking space',
  'finance.mortgagePay.form.house.selectPrompt': 'Please select house',
  'finance.mortgagePay.form.owner.label': 'Owner',
  'finance.mortgagePay.form.owner.placeholder': 'Please select house',
  'finance.mortgagePay.form.owner.required': 'Please select house',
  'finance.mortgagePay.form.amount.label': 'Repayment Amount',
  'finance.mortgagePay.form.amount.placeholder':
    'Please enter repayment amount',
  'finance.mortgagePay.form.amount.required': 'Please enter repayment amount',
  'finance.mortgagePay.form.amount.min': 'Amount cannot be less than 0',
  'finance.mortgagePay.form.remarks.label': 'Remarks',
  'finance.mortgagePay.form.remarks.placeholder': 'Please enter remarks',
  'finance.mortgagePay.form.remarks.max':
    'Remarks cannot exceed 500 characters',
  'finance.mortgagePay.form.paymentType.label': 'Repayment Type',
  'finance.mortgagePay.form.paymentType.placeholder':
    'Please select repayment type',
  'finance.mortgagePay.form.paymentType.required':
    'Please select repayment type',
  'finance.mortgagePay.form.paymentType.mortgage': 'Mortgage',
  'finance.mortgagePay.form.paymentType.rent': 'Rent',
  'finance.mortgagePay.upload.multipleSupport':
    'Multiple file upload is supported',
  'finance.mortgagePay.upload.error.uploadFormat':
    'Invalid upload response format',
  'finance.mortgagePay.message.paymentTypeChanged':
    'Repayment type changed, please reselect house to refresh amount',
  'finance.mortgagePay.form.repaymentType.label': 'Repayment Type',
  'finance.mortgagePay.form.repaymentType.required':
    'Please select repayment type',
  'finance.mortgagePay.message.getDetailFailed':
    'Failed to get repayment details',
  'finance.mortgagePay.message.getBankStatementDetailFailed':
    'Failed to get bank statement details',
  'finance.mortgagePay.message.getAuditRecordsFailed':
    'Failed to get audit records',
  'finance.mortgagePay.message.loadProjectNameFailed':
    'Failed to load project names',
  'finance.mortgagePay.message.bankStatementNotFound':
    'Bank statement information failed to load',
  'finance.mortgagePay.message.batchCreate.success':
    'Batch creation successful, {count} records created',
  'finance.mortgagePay.message.batchCreate.completed':
    'Batch creation completed, {count} records created',
  'finance.mortgagePay.message.batchCreate.processing':
    'Batch creation task submitted, data is being processed in the background, please refresh later to view results...',
  'finance.mortgagePay.message.batchCreate.failed': 'Batch creation failed',
  'finance.mortgagePay.message.batchCreateFailed.console':
    'Batch creation failed',
  'finance.mortgagePay.confirm.delete':
    'Are you sure you want to delete this repayment record?',
  'finance.mortgagePay.loading': 'Loading...',
  'finance.mortgagePay.empty.auditRecords': 'No audit records',
  'finance.mortgagePay.empty.bankStatement': 'No related bank statement',
  'finance.mortgagePay.summary.houseInfo': 'House Information',
  'finance.mortgagePay.summary.amount': 'Repayment Amount',
  'finance.mortgagePay.batchCreate.description.title': 'Description:',
  'finance.mortgagePay.batchCreate.description.content':
    'The system will query sold and rented houses based on the specified billing period, and create draft repayment records for houses without existing records.',
  'finance.mortgagePay.batchCreate.tab.single': 'Single Create',
  'finance.mortgagePay.batchCreate.tab.range': 'Batch Create',
  'finance.mortgagePay.form.periodRange.label': 'Billing Period Range',
  'finance.mortgagePay.form.periodRange.required':
    'Please select billing period range',
  'finance.mortgagePay.batchCreate.progress':
    'Processing {period} ({current}/{total})',
  'finance.mortgagePay.message.batchCreate.rangeSuccess':
    'Batch creation completed, {count} billing periods processed',
  'finance.mortgagePay.message.batchCreate.partialFailed':
    'Some billing periods failed, {success} succeeded, failed periods: {failed}',
  'finance.mortgagePay.message.batchCreate.invalidRange':
    'Please select a valid billing period range',
  'finance.mortgagePay.action.batchRevoke': 'Batch Revoke',
  'finance.mortgagePay.confirm.batchRevoke':
    'Are you sure you want to batch revoke the selected repayment audits?',
  'finance.mortgagePay.confirm.batchRevokeDesc':
    'Will revoke {count} approved or rejected repayment records and restore them to pending',
  'finance.mortgagePay.modal.batchRevokeTitle': 'Batch Revoke Progress',
  'finance.mortgagePay.batchRevoke.progress':
    'Revoking ({current}/{total}), success {success}, failed {failed}',
  'finance.mortgagePay.message.batchRevoke.success':
    'Batch revoke successful, {count} records revoked',
  'finance.mortgagePay.message.batchRevoke.partial':
    'Batch revoke completed, {success} succeeded, {failed} failed',
  'finance.mortgagePay.message.batchRevoke.failed': 'Batch revoke failed',

  // Car Pay (Parking Space Repayment)
  'finance.carPay.pageTitle': 'Parking Space Repayment',
  'finance.carPay.pageSubTitle': 'Parking Space Repayment Management',
  'finance.carPay.headerTitle': 'Parking Space Repayment',
  'finance.carPay.action.create': 'New Repayment',
  'finance.carPay.action.exportExcel': 'Export Excel',
  'finance.carPay.action.upload': 'Click to upload attachment',
  'finance.carPay.action.downloadOriginal': 'Download original file',
  'finance.carPay.action.searchParking': 'Search',
  'finance.carPay.action.submitAudit': 'Submit for Review',
  'finance.carPay.confirm.delete':
    'Are you sure you want to delete this repayment record?',
  'finance.carPay.confirm.batchDelete':
    'Are you sure you want to batch delete the selected repayment records?',
  'finance.carPay.message.getDetailFailed': 'Failed to get repayment details',
  'finance.carPay.message.generateCodeFailed':
    'Failed to generate repayment code',
  'finance.carPay.message.update.success':
    'Repayment record updated successfully',
  'finance.carPay.message.update.failed': 'Failed to update repayment record',
  'finance.carPay.message.create.success':
    'Repayment record created successfully',
  'finance.carPay.message.create.failed': 'Failed to create repayment record',
  'finance.carPay.column.billingPeriod': 'Billing Period',
  'finance.carPay.column.type': 'Type',
  'finance.carPay.column.code': 'Repayment Code',
  'finance.carPay.column.parkingInfo': 'Parking Space Information',
  'finance.carPay.column.repaymentHistory': 'Repayment History',
  'finance.carPay.column.repaymentType': 'Repayment Type',
  'finance.carPay.column.projectName': 'Project Name',
  'finance.carPay.column.bank': 'Bank',
  'finance.carPay.column.amount': 'Due Amount',
  'finance.carPay.column.receiptAmount': 'Actual Amount',
  'finance.carPay.column.repaymentAmount': 'Repayment Amount',
  'finance.carPay.column.dueAmount': 'Due',
  'finance.carPay.column.actualAmount': 'Paid',
  'finance.carPay.column.repaymentTime': 'Repayment Time',
  'finance.carPay.column.dueDate': 'Due',
  'finance.carPay.column.receiptDate': 'Paid',
  'finance.carPay.column.status': 'Status',
  'finance.carPay.column.remarks': 'Remarks',
  'finance.carPay.detail.title': 'Parking Space Repayment Details',
  'finance.carPay.modal.detailTitle': 'Parking Space Repayment Details',
  'finance.carPay.label.code': 'Repayment Code',
  'finance.carPay.label.billingPeriod': 'Billing Period',
  'finance.carPay.label.amount': 'Repayment Amount',
  'finance.carPay.label.bank': 'Bank',
  'finance.carPay.label.status': 'Status',
  'finance.carPay.label.projectName': 'Project Name',
  'finance.carPay.label.parkingInfo': 'Parking Space Information',
  'finance.carPay.label.ownerInfo': 'Owner Information',
  'finance.carPay.label.email': 'Email',
  'finance.carPay.label.ownerId': 'Owner ID',
  'finance.carPay.label.attachment': 'Attachment',
  'finance.carPay.label.auditRecord': 'Audit Record',
  'finance.carPay.label.remarks': 'Remarks',
  'finance.carPay.section.basic': 'Basic Information',
  'finance.carPay.section.parkingOwner': 'Parking Space and Owner Information',
  'finance.carPay.section.attachment': 'Attachment',
  'finance.carPay.section.other': 'Other Information',
  'finance.carPay.section.bankStatement': 'Related Bank Statement',
  'finance.carPay.section.auditRecords': 'Audit Records',
  'finance.carPay.section.remark': 'Remarks',
  'finance.carPay.loading': 'Loading...',
  'finance.carPay.empty.auditRecords': 'No audit records',
  'finance.carPay.message.bankStatementNotFound':
    'Bank statement information failed to load',
  'finance.carPay.drawer.title.edit': 'Edit Parking Space Repayment',
  'finance.carPay.drawer.title.create': 'New Parking Space Repayment',
  'finance.carPay.form.code.label': 'Repayment Code',
  'finance.carPay.form.code.placeholder': 'Please enter repayment code',
  'finance.carPay.form.code.required': 'Please enter repayment code',
  'finance.carPay.form.code.max': 'Code length cannot exceed 100 characters',
  'finance.carPay.form.billingPeriod.label': 'Billing Period',
  'finance.carPay.form.billingPeriod.placeholder':
    'Please select billing period',
  'finance.carPay.form.billingPeriod.required': 'Please select billing period',
  'finance.carPay.form.parking.label': 'Parking Space',
  'finance.carPay.form.parking.placeholder': 'Please select parking space',
  'finance.carPay.form.parking.required': 'Please select parking space',
  'finance.carPay.form.type.label': 'Repayment Type',
  'finance.carPay.form.type.placeholder': 'Please select repayment type',
  'finance.carPay.form.type.required': 'Please select repayment type',
  'finance.carPay.form.ownerName.label': 'Parking Space Owner',
  'finance.carPay.form.ownerName.placeholder': 'Parking Space Owner',
  'finance.carPay.form.bank.label': 'Receiving Bank',
  'finance.carPay.form.bank.placeholder': 'Please select receiving bank',
  'finance.carPay.form.bank.required': 'Please select receiving bank',
  'finance.carPay.form.amount.label': 'Repayment Amount',
  'finance.carPay.form.amount.placeholder': 'Please enter repayment amount',
  'finance.carPay.form.amount.required': 'Please enter repayment amount',
  'finance.carPay.form.amount.min': 'Amount cannot be less than 0',
  'finance.carPay.form.bankStatement.label': 'Related Bank Statement',
  'finance.carPay.form.bankStatement.placeholder':
    'Please select related bank statement',
  'finance.carPay.form.remark.label': 'Remarks',
  'finance.carPay.form.remark.placeholder': 'Please enter remarks',
  'finance.carPay.form.remark.max':
    'Remarks length cannot exceed 500 characters',
  'finance.carPay.form.attachment.label': 'Attachment',
  'finance.carPay.form.attachment.upload': 'Upload attachment',
  'finance.carPay.upload.multipleSupport':
    'Multiple file upload is supported. You can select multiple files at once',
  'finance.carPay.message.paymentTypeChanged':
    'Repayment type changed, please reselect parking space to refresh amount',
  'finance.carPay.message.selectForAudit':
    'Please select repayment records to submit for review',
  'finance.carPay.message.submitAudit.success':
    'Submitted for review successfully',
  'finance.carPay.message.submitAudit.failed': 'Failed to submit for review',
  'finance.carPay.audit.title': 'Submit for Review',
  'finance.carPay.modal.submitAuditTitle': 'Submit for Review',
  'finance.carPay.audit.auditName': 'Review Name',
  'finance.carPay.audit.auditName.required': 'Please enter review name',
  'finance.carPay.audit.remark': 'Submission Note',
  'finance.carPay.audit.defaultName':
    'Parking Space Repayment Batch Review ({count} items)',
  'finance.carPay.form.auditName.label': 'Review Name',
  'finance.carPay.form.auditName.placeholder': 'Please enter review name',
  'finance.carPay.form.auditName.required': 'Please enter review name',
  'finance.carPay.form.submitRemark.label': 'Submission Note',
  'finance.carPay.form.submitRemark.placeholder':
    'Please enter submission note',
  'finance.carPay.selectedBills': 'Selected {count} repayment records',
  'finance.carPay.status.draft': 'Draft',
  'finance.carPay.status.pending': 'Pending',
  'finance.carPay.status.approved': 'Approved',
  'finance.carPay.status.rejected': 'Rejected',
  'finance.carPay.status.overdue': 'Overdue',
  'finance.carPay.type.rent': 'Rent',
  'finance.carPay.type.mortgage': 'Mortgage',
  'finance.carPay.action.batchCreate': 'Batch Repayment',
  'finance.carPay.modal.batchCreateTitle':
    'Batch Create Parking Space Repayment Records',
  'finance.carPay.message.batchCreate.success':
    'Batch creation successful, {count} records created',
  'finance.carPay.message.batchCreate.failed': 'Batch creation failed',
  'finance.carPay.batchCreate.description.title': 'Description:',
  'finance.carPay.batchCreate.description.content':
    'The system will query sold and rented parking spaces based on the specified billing period, and create draft repayment records for parking spaces without existing records.',
  'finance.carPay.action.batchRevoke': 'Batch Revoke',
  'finance.carPay.confirm.batchRevoke':
    'Are you sure you want to batch revoke the selected repayment audits?',
  'finance.carPay.confirm.batchRevokeDesc':
    'Will revoke {count} approved or rejected repayment records and restore them to pending',
  'finance.carPay.modal.batchRevokeTitle': 'Batch Revoke Progress',
  'finance.carPay.batchRevoke.progress':
    'Revoking ({current}/{total}), success {success}, failed {failed}',
  'finance.carPay.message.batchRevoke.success':
    'Batch revoke successful, {count} records revoked',
  'finance.carPay.message.batchRevoke.partial':
    'Batch revoke completed, {success} succeeded, {failed} failed',
  'finance.carPay.message.batchRevoke.failed': 'Batch revoke failed',
  // Budget Request - Additional translations
  'finance.budgetRequest.section.relatedInfo': 'Related Information',
  'finance.budgetRequest.section.personnelInfo': 'Personnel Information',
  'finance.budgetRequest.upload.multipleSupport':
    'Multiple file upload is supported. You can select multiple files at once',

  // Bank Statement
  'finance.bankStatement.headerTitle': 'Bank Statement Management',
  'finance.bankStatement.pageTitle': 'Bank Statement',
  'finance.bankStatement.action.create': 'New Bank Statement',
  'finance.bankStatement.action.batchCreate': 'Batch Create',
  'finance.bankStatement.action.upload': 'Click to upload statement file',
  'finance.bankStatement.action.downloadOriginal': 'Download Original File',
  'finance.bankStatement.action.settle': 'Settle',
  'finance.bankStatement.confirm.delete':
    'Are you sure you want to delete this bank statement?',
  'finance.bankStatement.confirm.batchDelete':
    'Are you sure you want to batch delete selected bank statements?',
  'finance.bankStatement.message.getDetailFailed':
    'Failed to get bank statement details',
  'finance.bankStatement.message.loadDetailFailed':
    'Failed to load bank statement details',
  'finance.bankStatement.message.generateNoFailed':
    'Failed to generate statement number',
  'finance.bankStatement.message.pleaseUpload':
    'Please upload a statement file',
  'finance.bankStatement.message.update.success':
    'Bank statement updated successfully',
  'finance.bankStatement.message.update.failed':
    'Failed to update bank statement',
  'finance.bankStatement.message.create.success':
    'Bank statement created successfully',
  'finance.bankStatement.message.create.failed':
    'Failed to create bank statement',
  'finance.bankStatement.message.batchCreate.success':
    'Batch creation successful',
  'finance.bankStatement.message.batchCreate.failed': 'Batch creation failed',
  'finance.bankStatement.message.selectBillingPeriod':
    'Please select a billing period',
  'finance.bankStatement.column.billingPeriod': 'Billing Period',
  'finance.bankStatement.column.statementNo': 'Statement No.',
  'finance.bankStatement.column.bank': 'Bank',
  'finance.bankStatement.column.monthBegAmount': 'Beginning Balance',
  'finance.bankStatement.column.totalIncome': 'Total Income',
  'finance.bankStatement.column.totalExpense': 'Total Expense',
  'finance.bankStatement.column.status': 'Settlement Status',
  'finance.bankStatement.column.remarks': 'Remarks',
  'finance.bankStatement.column.reviewer': 'Reviewer',
  'finance.bankStatement.column.reviewTime': 'Review Time',
  'finance.bankStatement.column.reviewIp': 'Operation IP',
  'finance.bankStatement.status.settled': 'Settled',
  'finance.bankStatement.status.unsettled': 'Unsettled',
  'finance.bankStatement.modal.detailTitle': 'Bank Statement Details',
  'finance.bankStatement.modal.batchCreateTitle':
    'Batch Create Bank Statements',
  'finance.bankStatement.drawer.title.edit': 'Edit Bank Statement',
  'finance.bankStatement.drawer.title.create': 'New Bank Statement',
  'finance.bankStatement.tab.detail': 'Statement Details',
  'finance.bankStatement.tab.expenses': 'Statement Entries',
  'finance.bankStatement.label.statementNo': 'Statement No.',
  'finance.bankStatement.label.billingPeriod': 'Billing Period',
  'finance.bankStatement.label.bank': 'Bank',
  'finance.bankStatement.label.monthBegAmount': 'Beginning Balance',
  'finance.bankStatement.label.totalIncome': 'Total Income',
  'finance.bankStatement.label.totalExpense': 'Total Expense',
  'finance.bankStatement.label.pdfKey': 'PDF Key',
  'finance.bankStatement.label.statementFile': 'Statement File',
  'finance.bankStatement.label.remarks': 'Remarks',
  'finance.bankStatement.form.statementNo.label': 'Statement No.',
  'finance.bankStatement.form.statementNo.placeholder':
    'Please enter statement number',
  'finance.bankStatement.form.statementNo.required':
    'Please enter statement number',
  'finance.bankStatement.form.statementNo.max':
    'Statement number cannot exceed 100 characters',
  'finance.bankStatement.form.statementNo.exists':
    'Statement number already exists, please modify it',
  'finance.bankStatement.form.bank.label': 'Bank',
  'finance.bankStatement.form.bank.placeholder': 'Please select a bank',
  'finance.bankStatement.form.bank.required': 'Please select a bank',
  'finance.bankStatement.form.billingPeriod.label': 'Billing Period',
  'finance.bankStatement.form.billingPeriod.placeholder':
    'Please select billing period',
  'finance.bankStatement.form.billingPeriod.required':
    'Billing period is required',
  'finance.bankStatement.form.pdfKey.label': 'PDF Key',
  'finance.bankStatement.form.pdfKey.placeholder': 'Please enter PDF key',
  'finance.bankStatement.form.pdfKey.max':
    'PDF key cannot exceed 200 characters',
  'finance.bankStatement.form.monthBegAmount.label': 'Beginning Balance',
  'finance.bankStatement.form.monthBegAmount.placeholder':
    'Please enter beginning balance',
  'finance.bankStatement.form.monthBegAmount.invalid':
    'Please enter a valid amount',
  'finance.bankStatement.form.remarks.label': 'Remarks',
  'finance.bankStatement.form.remarks.placeholder': 'Please enter remarks',
  'finance.bankStatement.form.remarks.max':
    'Remarks cannot exceed 500 characters',
  'finance.bankStatement.section.basic': 'Basic Information',
  'finance.bankStatement.section.amount': 'Amount Information',
  'finance.bankStatement.section.statementFile': 'Statement File',
  'finance.bankStatement.section.other': 'Other Information',
  'finance.bankStatement.batchCreate.tip':
    'Statements for the specified billing period will be created for all banks',
  'finance.bankStatement.expenses.includeUnsettled':
    'Include unapproved entries:',
  'finance.bankStatement.expenses.total': '{count} entries in total',
  'finance.bankStatement.expenses.column.code': 'Code',
  'finance.bankStatement.expenses.column.name': 'Name',
  'finance.bankStatement.expenses.column.type': 'Type',
  'finance.bankStatement.expenses.column.amountType': 'Amount Type',
  'finance.bankStatement.expenses.column.amount': 'Amount',
  'finance.bankStatement.expenses.column.status': 'Status',
  'finance.bankStatement.expenses.column.createdTime': 'Created Time',
  'finance.bankStatement.expenses.amountType.in': 'Income',
  'finance.bankStatement.expenses.amountType.out': 'Expense',
  'finance.bankStatement.expenses.status.draft': 'Draft',
  'finance.bankStatement.expenses.status.pending': 'Pending',
  'finance.bankStatement.expenses.status.approved': 'Approved',
  'finance.bankStatement.expenses.status.rejected': 'Rejected',
  'finance.bankStatement.expenses.pagination.total': 'Total {total} entries',
  'finance.bankStatement.expenses.loadFailed':
    'Failed to load statement entries',
  'finance.bankStatement.switch.yes': 'Yes',
  'finance.bankStatement.switch.no': 'No',

  // Project Management
  'finance.project.headerTitle': 'Project Management',
  'finance.project.action.create': 'New Project',
  'finance.project.confirm.delete':
    'Are you sure you want to delete this project?',
  'finance.project.confirm.batchDelete':
    'Are you sure you want to batch delete the selected projects?',
  'finance.project.message.getDetailFailed': 'Failed to get project details',
  'finance.project.message.delete.success': 'Deleted successfully',
  'finance.project.message.delete.failed': 'Failed to delete',
  'finance.project.message.batchDelete.success': 'Batch deletion successful',
  'finance.project.message.batchDelete.failed': 'Batch deletion failed',
  'finance.project.message.update.success': 'Updated successfully',
  'finance.project.message.update.failed': 'Failed to update',
  'finance.project.message.create.success': 'Created successfully',
  'finance.project.message.create.failed': 'Failed to create',
  'finance.project.column.type': 'Category Association',
  'finance.project.column.projectName': 'Project Name',
  'finance.project.column.loanBank': 'Loan Receiving Bank',
  'finance.project.column.propertyFeeBank': 'Property Fee Receiving Bank',
  'finance.project.column.normalReceiveBank': 'Normal Receiving Bank',
  'finance.project.column.loanBankStatement': 'Loan Bank Statement',
  'finance.project.column.propertyFeeBankStatement':
    'Property Fee Bank Statement',
  'finance.project.column.normalReceiveBankStatement':
    'Normal Receiving Bank Statement',
  'finance.project.column.status': 'Status',
  'finance.project.column.sort': 'Sort',
  'finance.project.column.action': 'Action',
  'finance.project.status.enabled': 'Enabled',
  'finance.project.status.disabled': 'Disabled',
  'finance.project.action.view': 'View',
  'finance.project.action.edit': 'Edit',
  'finance.project.action.delete': 'Delete',
  'finance.project.action.batchDelete': 'Batch Delete',
  'finance.project.action.ok': 'OK',
  'finance.project.action.cancel': 'Cancel',
  'finance.project.action.close': 'Close',
  'finance.project.table.selected': 'Selected {count} items',
  'finance.project.table.clearSelected': 'Clear Selection',
  'finance.project.modal.detailTitle': 'Project Details',
  'finance.project.label.type': 'Category Association',
  'finance.project.label.projectName': 'Project Name',
  'finance.project.label.sort': 'Sort',
  'finance.project.label.status': 'Status',
  'finance.project.label.loanBank': 'Loan Receiving Bank',
  'finance.project.label.propertyFeeBank': 'Property Fee Receiving Bank',
  'finance.project.label.normalReceiveBank': 'Normal Receiving Bank',
  'finance.project.label.loanBankStatement': 'Loan Bank Statement',
  'finance.project.label.propertyFeeBankStatement':
    'Property Fee Bank Statement',
  'finance.project.label.normalReceiveBankStatement':
    'Normal Receiving Bank Statement',
  'finance.project.label.remarks': 'Remarks',
  'finance.project.label.createdTime': 'Created Time',
  'finance.project.label.updatedTime': 'Updated Time',
  'finance.project.drawer.title.edit': 'Edit Project',
  'finance.project.drawer.title.create': 'New Project',
  'finance.project.form.type.label': 'Category Association',
  'finance.project.form.type.placeholder': 'Please select category association',
  'finance.project.form.projectName.label': 'Project Name',
  'finance.project.form.projectName.placeholder': 'Please enter project name',
  'finance.project.form.projectName.required': 'Please enter project name',
  'finance.project.form.loanBank.label': 'Loan Receiving Bank',
  'finance.project.form.loanBank.placeholder':
    'Please select loan receiving bank',
  'finance.project.form.propertyFeeBank.label': 'Property Fee Receiving Bank',
  'finance.project.form.propertyFeeBank.placeholder':
    'Please select property fee receiving bank',
  'finance.project.form.normalReceiveBank.label': 'Normal Receiving Bank',
  'finance.project.form.normalReceiveBank.placeholder':
    'Please select normal receiving bank',
  'finance.project.form.loanBankStatement.label': 'Loan Bank Statement',
  'finance.project.form.loanBankStatement.placeholder':
    'Please select loan bank statement',
  'finance.project.form.propertyFeeBankStatement.label':
    'Property Fee Bank Statement',
  'finance.project.form.propertyFeeBankStatement.placeholder':
    'Please select property fee bank statement',
  'finance.project.form.normalReceiveBankStatement.label':
    'Normal Receiving Bank Statement',
  'finance.project.form.normalReceiveBankStatement.placeholder':
    'Please select normal receiving bank statement',
  'finance.project.form.status.label': 'Status',
  'finance.project.form.status.required': 'Please select status',
  'finance.project.form.sort.label': 'Sort',
  'finance.project.form.sort.placeholder': 'Please enter sort order',
  'finance.project.form.sort.required': 'Please enter sort order',
  'finance.project.form.remarks.label': 'Remarks',
  'finance.project.form.remarks.placeholder': 'Please enter remarks',

  // Bank Management
  'finance.bank.headerTitle': 'Bank Management',
  'finance.bank.action.create': 'New Bank',
  'finance.bank.confirm.toggleStatus.disable':
    'Are you sure you want to disable this bank?',
  'finance.bank.confirm.toggleStatus.enable':
    'Are you sure you want to enable this bank?',
  'finance.bank.message.getDetailFailed': 'Failed to get bank details',
  'finance.bank.message.toggleStatus.enable.success': 'Enabled successfully',
  'finance.bank.message.toggleStatus.disable.success': 'Disabled successfully',
  'finance.bank.message.toggleStatus.enable.failed': 'Failed to enable',
  'finance.bank.message.toggleStatus.disable.failed': 'Failed to disable',
  'finance.bank.message.create.success': 'Created successfully',
  'finance.bank.message.update.success': 'Updated successfully',
  'finance.bank.column.logoUrl': 'Bank Logo',
  'finance.bank.column.bankName': 'Bank Name',
  'finance.bank.column.bankName.required': 'Bank name is required',
  'finance.bank.column.bankNickname': 'Bank Nickname',
  'finance.bank.column.bankNickname.required': 'Please enter bank nickname',
  'finance.bank.column.currency': 'Currency',
  'finance.bank.column.purposeDesc': 'Purpose Description',
  'finance.bank.column.lastAmount': 'Snapshot Amount',
  'finance.bank.column.lastUpdateTime': 'Snapshot Time',
  'finance.bank.column.isPayment': 'Mobile Payment',
  'finance.bank.column.status': 'Status',
  'finance.bank.column.sort': 'Sort',
  'finance.bank.column.remarks': 'Remarks',
  'finance.bank.column.action': 'Action',
  'finance.bank.status.enabled': 'Enabled',
  'finance.bank.status.disabled': 'Disabled',
  'finance.bank.status.unknown': 'Unknown',
  'finance.bank.isPayment.yes': 'Yes',
  'finance.bank.isPayment.no': 'No',
  'finance.bank.action.view': 'View',
  'finance.bank.action.edit': 'Edit',
  'finance.bank.action.enable': 'Enable',
  'finance.bank.action.disable': 'Disable',
  'finance.bank.action.ok': 'OK',
  'finance.bank.action.cancel': 'Cancel',
  'finance.bank.action.close': 'Close',
  'finance.bank.modal.createTitle': 'New Bank',
  'finance.bank.modal.editTitle': 'Edit Bank',
  'finance.bank.modal.detailTitle': 'Bank Details',
  'finance.bank.label.bankName': 'Bank Name',
  'finance.bank.label.bankCode': 'Bank Nickname',
  'finance.bank.label.bankNickname': 'Bank Nickname',
  'finance.bank.label.currency': 'Currency',
  'finance.bank.label.accountNumber': 'Bank Account',
  'finance.bank.label.accountHolder': 'Account Holder',
  'finance.bank.label.isPayment': 'Mobile Payment',
  'finance.bank.label.status': 'Status',
  'finance.bank.label.logoUrl': 'Bank Logo',
  'finance.bank.label.purposeDesc': 'Purpose Description',
  'finance.bank.label.remarks': 'Remarks',
  'finance.bank.label.createdTime': 'Created Time',
  'finance.bank.label.updatedTime': 'Updated Time',
  // Bank Form
  'finance.bank.form.message.getDetailFailed': 'Failed to get bank details',
  'finance.bank.form.message.updateFailed': 'Update failed',
  'finance.bank.form.message.createFailed': 'Create failed',
  'finance.bank.form.message.bankAddedSuccess': 'Bank added successfully',
  'finance.bank.form.message.logoUploadSuccess': 'Logo uploaded successfully',
  'finance.bank.form.message.logoUploadFailed': 'Logo upload failed',
  'finance.bank.form.message.imageOnly': 'Only image files are allowed!',
  'finance.bank.form.message.imageSizeLimit': 'Image size cannot exceed 2MB!',
  'finance.bank.form.bankName.label': 'Bank Nickname',
  'finance.bank.form.bankName.placeholder': 'Please enter bank nickname',
  'finance.bank.form.bankName.required': 'Please enter bank nickname',
  'finance.bank.form.bankName.max':
    'Bank nickname cannot exceed 100 characters',
  'finance.bank.form.bankCode.label': 'Bank Name',
  'finance.bank.form.bankCode.placeholder': 'Please enter bank name',
  'finance.bank.form.bankCode.required': 'Please enter bank name',
  'finance.bank.form.bankCode.max': 'Bank name cannot exceed 50 characters',
  'finance.bank.form.bankSelector.label': 'Bank Name',
  'finance.bank.form.bankSelector.placeholder': 'Please select bank name',
  'finance.bank.form.bankSelector.required': 'Please select bank name',
  'finance.bank.form.bankSelector.addBank': 'Add',
  'finance.bank.form.accountNumber.label': 'Bank Account Number',
  'finance.bank.form.accountNumber.placeholder':
    'Please enter bank account number',
  'finance.bank.form.accountNumber.max':
    'Bank account number cannot exceed 50 characters',
  'finance.bank.form.accountNumber.exists':
    'This bank account already exists. Please check for duplicate entry',
  'finance.bank.form.accountHolder.label': 'Account Holder',
  'finance.bank.form.accountHolder.placeholder': 'Please enter account holder',
  'finance.bank.form.accountHolder.max':
    'Account holder cannot exceed 100 characters',
  'finance.bank.form.currency.label': 'Currency',
  'finance.bank.form.currency.placeholder': 'Please select currency',
  'finance.bank.form.currency.required': 'Please select currency',
  'finance.bank.form.isPayment.label': 'Mobile Payment',
  'finance.bank.form.isPayment.placeholder':
    'Please select mobile payment option',
  'finance.bank.form.isPayment.required': 'Please select mobile payment option',
  'finance.bank.form.sort.label': 'Sort',
  'finance.bank.form.sort.placeholder': 'Please enter sort order',
  'finance.bank.form.sort.invalid': 'Please enter a valid number',
  'finance.bank.form.status.label': 'Status',
  'finance.bank.form.status.placeholder': 'Please select status',
  'finance.bank.form.status.required': 'Please select status',
  'finance.bank.form.logoUrl.label': 'Bank Logo',
  'finance.bank.form.logoUrl.uploadText': 'Drag or click to upload',
  'finance.bank.form.logoUrl.changeText': 'Drag or click to replace image',
  'finance.bank.form.logoUrl.uploading': 'Uploading',
  'finance.bank.form.logoUrl.hint': 'Supports JPG/PNG/GIF/WEBP, up to 2MB',
  'finance.bank.form.purposeDesc.label': 'Purpose Description',
  'finance.bank.form.purposeDesc.placeholder':
    'Please enter purpose description',
  'finance.bank.form.purposeDesc.max':
    'Purpose description cannot exceed 500 characters',
  'finance.bank.form.remarks.label': 'Remarks',
  'finance.bank.form.remarks.placeholder': 'Please enter remarks',
  'finance.bank.form.remarks.max': 'Remarks cannot exceed 500 characters',
  'finance.bank.form.submit.update': 'Update',
  'finance.bank.form.submit.create': 'Create',
  'finance.bank.form.submit.cancel': 'Cancel',
  // Bank Snapshot Modal
  'finance.bank.snapshot.modal.title': 'Bank Card Monthly Snapshot Management',
  'finance.bank.snapshot.modal.addTitle': 'Add Snapshot',
  'finance.bank.snapshot.modal.previewTitle': 'Snapshot Preview',
  'finance.bank.snapshot.label.bankName': 'Bank Name',
  'finance.bank.snapshot.label.bankCode': 'Bank Nickname',
  'finance.bank.snapshot.label.currency': 'Currency',
  'finance.bank.snapshot.label.sort': 'Sort',
  'finance.bank.snapshot.label.accountNumber': 'Bank Account Number',
  'finance.bank.snapshot.label.accountHolder': 'Account Holder',
  'finance.bank.snapshot.label.purposeDesc': 'Purpose Description',
  'finance.bank.snapshot.label.remarks': 'Remarks',
  'finance.bank.snapshot.section.title': 'Snapshot History',
  'finance.bank.snapshot.section.hint':
    'Snapshot records older than 30 minutes cannot be deleted',
  'finance.bank.snapshot.action.refresh': 'Refresh',
  'finance.bank.snapshot.action.add': 'Add Snapshot',
  'finance.bank.snapshot.action.view': 'View',
  'finance.bank.snapshot.action.delete': 'Delete',
  'finance.bank.snapshot.confirm.delete':
    'Are you sure you want to delete this snapshot?',
  'finance.bank.snapshot.message.getListFailed': 'Failed to get snapshot list',
  'finance.bank.snapshot.message.deleteSuccess': 'Deleted successfully',
  'finance.bank.snapshot.message.deleteFailed': 'Failed to delete',
  'finance.bank.snapshot.message.noImage': 'No snapshot image',
  'finance.bank.snapshot.message.createSuccess': 'Snapshot added successfully',
  'finance.bank.snapshot.message.createFailed': 'Failed to add snapshot',
  'finance.bank.snapshot.message.uploadSuccess': 'Upload successful',
  'finance.bank.snapshot.message.imageOnly': 'Only image files are supported',
  'finance.bank.snapshot.message.imageSizeLimit':
    'Image size cannot exceed 5MB',
  'finance.bank.snapshot.message.uploadImageFirst':
    'Please upload a snapshot image first',
  'finance.bank.snapshot.message.bankNotFound': 'Bank information not found',
  'finance.bank.snapshot.empty': 'No snapshot records',
  'finance.bank.snapshot.empty.image': 'No image',
  'finance.bank.snapshot.pagination.total': 'Total {total} items',
  'finance.bank.snapshot.form.recordDate.label': 'Record Date',
  'finance.bank.snapshot.form.recordDate.required': 'Please select record date',
  'finance.bank.snapshot.form.amount.label': 'Current Balance (PHP)',
  'finance.bank.snapshot.form.amount.placeholder':
    'Please enter balance amount',
  'finance.bank.snapshot.form.amount.required': 'Please enter balance amount',
  'finance.bank.snapshot.form.remark.label': 'Remark',
  'finance.bank.snapshot.form.remark.placeholder':
    'Describe special notes if needed',
  'finance.bank.snapshot.form.image.label': 'Snapshot Image (JPG/PNG, <=5MB)',
  'finance.bank.snapshot.form.image.uploadText':
    'Click or drag to upload bank card balance screenshot',
  'finance.bank.snapshot.form.image.hint':
    'Supports JPG/PNG, file size up to 5MB',
  'finance.bank.snapshot.form.submit': 'Submit Snapshot',
  'finance.bank.snapshot.form.reset': 'Reset',

  // Common
  'common.all': 'All',
  'common.action.view': 'View',
  'common.action.edit': 'Edit',
  'common.action.delete': 'Delete',
  'common.action.ok': 'OK',
  'common.action.cancel': 'Cancel',
  'common.action.search': 'Search',
  'common.action.reset': 'Reset',
  'common.action.close': 'Close',
  'common.action.downloadFile': 'Download File',
  'common.label.createdBy': 'Created By',
  'common.label.createdTime': 'Created Time',
  'common.label.updatedTime': 'Updated Time',
  'common.label.fileFormat': 'File Format: ',
  'common.message.delete.success': 'Deleted successfully',
  'common.message.delete.failed': 'Failed to delete',
  'common.column.action': 'Action',

  // Property Reviewed (Repayment Audited)
  'audit.propertyReviewed.pageSubTitle': 'View reviewed repayment records',
  'audit.propertyReviewed.tableTitle': 'Repayment Search',
  // Search - Mortgage Statistics
  'search.mortgageStatistics.tab.mortgage': 'Mortgage Repayment',
  'search.mortgageStatistics.tab.car': 'Parking Repayment',
  'search.mortgageStatistics.page.subTitle':
    'Overdue days start counting from the date that is {days} days after the earliest unpaid record creation time.',
  'search.mortgageStatistics.headerTitle.mortgage':
    'Mortgage Overdue Statistics',
  'search.mortgageStatistics.headerTitle.car': 'Parking Overdue Statistics',
  'search.mortgageStatistics.type.rent': 'Rent',
  'search.mortgageStatistics.type.mortgage': 'Mortgage',
  'search.mortgageStatistics.status.draft': 'Draft',
  'search.mortgageStatistics.status.pending': 'Pending',
  'search.mortgageStatistics.status.approved': 'Approved',
  'search.mortgageStatistics.status.rejected': 'Rejected',
  'search.mortgageStatistics.status.overdue': 'Overdue',
  'search.mortgageStatistics.risk.critical': 'Critical Risk',
  'search.mortgageStatistics.risk.high': 'High Risk',
  'search.mortgageStatistics.risk.medium': 'Medium Risk',
  'search.mortgageStatistics.risk.low': 'Low Risk',
  'search.mortgageStatistics.risk.levelWithDays': '{level} ({days}+ days)',
  'search.mortgageStatistics.column.building': 'Building',
  'search.mortgageStatistics.column.buildingName': 'Building Name',
  'search.mortgageStatistics.column.floor': 'Floor',
  'search.mortgageStatistics.column.structure': 'Structure',
  'search.mortgageStatistics.column.houseNumber': 'House No.',
  'search.mortgageStatistics.column.parkingNumber': 'Parking No.',
  'search.mortgageStatistics.column.owner': 'Owner',
  'search.mortgageStatistics.column.overdueStartDate': 'Overdue Date',
  'search.mortgageStatistics.column.overdueDays': 'Overdue Days',
  'search.mortgageStatistics.column.overdueAmount': 'Total Overdue Amount',
  'search.mortgageStatistics.column.riskLevel': 'Risk Level',
  'search.mortgageStatistics.tooltip.overdueStart':
    'Earliest unpaid record created: {date} (count starts after {days} days)',
  'search.mortgageStatistics.unit.days': '{days} days',
  'search.mortgageStatistics.search.keyword': 'Keyword',
  'search.mortgageStatistics.search.placeholderMortgage':
    'Search by building, house number, owner name, or phone',
  'search.mortgageStatistics.search.placeholderCar':
    'Search by building, structure, parking number, owner name, or phone',
  'search.mortgageStatistics.modal.titleMortgage':
    '{building} {floor} House {houseNumber} Repayment Records',
  'search.mortgageStatistics.modal.titleCar':
    '{building} {structure} Parking {parkingNumber} Repayment Records',
  'search.mortgageStatistics.label.totalAmountMortgage':
    'Total repayment amount (house): ',
  'search.mortgageStatistics.label.totalAmountCar':
    'Total repayment amount (parking): ',
  'search.mortgageStatistics.detail.column.code': 'Repayment Code',
  'search.mortgageStatistics.detail.column.billingPeriod': 'Billing Period',
  'search.mortgageStatistics.detail.column.type': 'Type',
  'search.mortgageStatistics.detail.column.amount': 'Repayment Amount',
  'search.mortgageStatistics.detail.column.bank': 'Bank',
  'search.mortgageStatistics.detail.column.status': 'Status',
  'search.mortgageStatistics.detail.column.createdTime': 'Created Time',
  // Daily Report
  'finance.dailyReport.tab.daily': 'Daily Reconciliation',
  'finance.dailyReport.tab.monthly': 'Monthly Reconciliation',
  'finance.dailyReport.headerTitle': 'Daily Reconciliation Report',
  'finance.dailyReport.action.generate': 'Generate Report',
  'finance.dailyReport.action.batchGenerate': 'Batch Generate',
  'finance.dailyReport.action.viewDetail': 'View Details',
  'finance.dailyReport.column.reportDate': 'Report Date',
  'finance.dailyReport.column.bankName': 'Bank Name',
  'finance.dailyReport.column.totalIncome': 'Total Income',
  'finance.dailyReport.column.incomeCount': 'Income Count',
  'finance.dailyReport.column.totalExpense': 'Total Expense',
  'finance.dailyReport.column.expenseCount': 'Expense Count',
  'finance.dailyReport.column.netAmount': 'Net Amount',
  'finance.dailyReport.column.action': 'Action',
  'finance.dailyReport.bankName.cash': 'Cash',
  'finance.dailyReport.modal.generateTitle': 'Generate Daily Report',
  'finance.dailyReport.modal.batchGenerateTitle':
    'Batch Generate Daily Reports',
  'finance.dailyReport.form.reportDate.label': 'Report Date',
  'finance.dailyReport.form.reportDate.required': 'Please select report date',
  'finance.dailyReport.form.dateRange.label': 'Date Range',
  'finance.dailyReport.form.dateRange.required': 'Please select date range',
  'finance.dailyReport.message.generateSuccess':
    'Daily report generated successfully',
  'finance.dailyReport.message.generateFailed':
    'Failed to generate daily report',
  'finance.dailyReport.message.batchGenerateSuccess':
    'Daily reports generated in batch successfully',
  'finance.dailyReport.message.batchGenerateFailed':
    'Failed to batch generate daily reports',
  'finance.dailyReport.message.regenerateSuccess':
    'Report regenerated successfully',
  'finance.dailyReport.message.regenerateFailed': 'Failed to regenerate report',
  'finance.dailyReport.message.loadBankListFailed': 'Failed to load bank list',
  'finance.dailyReport.confirm.regenerateTitle': 'Confirm Regeneration',
  'finance.dailyReport.confirm.regenerateContent':
    'Are you sure you want to regenerate the report for {date}? Existing data will be overwritten.',
  // Daily Report Detail
  'finance.dailyReport.detail.title': 'Daily Reconciliation Details',
  'finance.dailyReport.detail.column.statementNo': 'Bank Statement',
  'finance.dailyReport.detail.column.code': 'Code',
  'finance.dailyReport.detail.column.name': 'Entry Name',
  'finance.dailyReport.detail.column.projectName': 'Project Name',
  'finance.dailyReport.detail.column.type': 'Type',
  'finance.dailyReport.detail.column.amountType': 'Amount Type',
  'finance.dailyReport.detail.column.amount': 'Amount',
  'finance.dailyReport.detail.column.fileUrl': 'Related File',
  'finance.dailyReport.detail.column.status': 'Status',
  'finance.dailyReport.detail.column.createdTime': 'Created Time',
  'finance.dailyReport.detail.amountType.in': 'Income',
  'finance.dailyReport.detail.amountType.out': 'Expense',
  'finance.dailyReport.detail.status.approved': 'Approved',
  'finance.dailyReport.detail.status.pending': 'Pending',
  'finance.dailyReport.detail.status.rejected': 'Rejected',
  'finance.dailyReport.detail.status.draft': 'Draft',
  'finance.dailyReport.detail.pagination.total': 'Total {total} items',
  'finance.dailyReport.detail.message.loadTypeDictFailed':
    'Failed to load type dictionary',
  'finance.dailyReport.detail.message.getDetailsFailed':
    'Failed to get detail list',
  'finance.dailyReport.summary.currentPage': 'Current Page Summary',
  'finance.dailyReport.summary.allPages': 'All Pages Summary',
  // Monthly Report
  'finance.monthlyReport.headerTitle': 'Monthly Reconciliation Report',
  'finance.monthlyReport.action.generate': 'Generate Report',
  'finance.monthlyReport.action.batchGenerate': 'Batch Generate',
  'finance.monthlyReport.action.viewDetail': 'View Details',
  'finance.monthlyReport.column.reportPeriod': 'Report Period',
  'finance.monthlyReport.column.bankName': 'Bank Name',
  'finance.monthlyReport.column.totalIncome': 'Total Income',
  'finance.monthlyReport.column.incomeCount': 'Income Count',
  'finance.monthlyReport.column.totalExpense': 'Total Expense',
  'finance.monthlyReport.column.expenseCount': 'Expense Count',
  'finance.monthlyReport.column.netAmount': 'Net Amount',
  'finance.monthlyReport.column.action': 'Action',
  'finance.monthlyReport.bankName.cash': 'Cash',
  'finance.monthlyReport.modal.generateTitle': 'Generate Monthly Report',
  'finance.monthlyReport.modal.batchGenerateTitle':
    'Batch Generate Monthly Reports',
  'finance.monthlyReport.form.reportPeriod.label': 'Report Period',
  'finance.monthlyReport.form.reportPeriod.required':
    'Please select report period',
  'finance.monthlyReport.form.periodRange.label': 'Period Range',
  'finance.monthlyReport.form.periodRange.required':
    'Please select period range',
  'finance.monthlyReport.message.generateSuccess':
    'Monthly report generated successfully',
  'finance.monthlyReport.message.generateFailed':
    'Failed to generate monthly report',
  'finance.monthlyReport.message.batchGenerateSuccess':
    'Monthly reports generated in batch successfully',
  'finance.monthlyReport.message.batchGenerateFailed':
    'Failed to batch generate monthly reports',
  'finance.monthlyReport.message.regenerateSuccess':
    'Report regenerated successfully',
  'finance.monthlyReport.message.regenerateFailed':
    'Failed to regenerate report',
  'finance.monthlyReport.message.loadBankListFailed':
    'Failed to load bank list',
  'finance.monthlyReport.confirm.regenerateTitle': 'Confirm Regeneration',
  'finance.monthlyReport.confirm.regenerateContent':
    'Are you sure you want to regenerate the report for {period}? Existing data will be overwritten.',
  // Monthly Report Detail
  'finance.monthlyReport.detail.title': 'Monthly Reconciliation Details',
  'finance.monthlyReport.detail.column.statementNo': 'Bank Statement',
  'finance.monthlyReport.detail.column.code': 'Code',
  'finance.monthlyReport.detail.column.name': 'Entry Name',
  'finance.monthlyReport.detail.column.projectName': 'Project Name',
  'finance.monthlyReport.detail.column.type': 'Type',
  'finance.monthlyReport.detail.column.amountType': 'Amount Type',
  'finance.monthlyReport.detail.column.amount': 'Amount',
  'finance.monthlyReport.detail.column.fileUrl': 'Related File',
  'finance.monthlyReport.detail.column.status': 'Status',
  'finance.monthlyReport.detail.column.createdTime': 'Created Time',
  'finance.monthlyReport.detail.amountType.in': 'Income',
  'finance.monthlyReport.detail.amountType.out': 'Expense',
  'finance.monthlyReport.detail.status.approved': 'Approved',
  'finance.monthlyReport.detail.status.pending': 'Pending',
  'finance.monthlyReport.detail.status.rejected': 'Rejected',
  'finance.monthlyReport.detail.status.draft': 'Draft',
  'finance.monthlyReport.detail.pagination.total': 'Total {total} items',
  'finance.monthlyReport.detail.message.loadTypeDictFailed':
    'Failed to load type dictionary',
  'finance.monthlyReport.detail.message.getDetailsFailed':
    'Failed to get detail list',
  'finance.monthlyReport.summary.currentPage': 'Current Page Summary',
  'finance.monthlyReport.summary.allPages': 'All Pages Summary',

  // Financial Report
  'finance.financialReport.pageTitle': 'Financial Report',
  'finance.financialReport.pageSubTitle':
    'Comprehensive financial data analysis and statistics',
  'finance.financialReport.filter.reportType': 'Report Type',
  'finance.financialReport.filter.reportType.monthly': 'Monthly Report',
  'finance.financialReport.filter.reportType.quarterly': 'Quarterly Report',
  'finance.financialReport.filter.reportType.yearly': 'Yearly Report',
  'finance.financialReport.filter.billingPeriod': 'Billing Period',
  'finance.financialReport.filter.projectName': 'Project Name',
  'finance.financialReport.filter.projectName.placeholder':
    'Please select project',
  'finance.financialReport.filter.bankStatement': 'Bank Statement',
  'finance.financialReport.filter.bankStatement.placeholder':
    'Please select bank statement',
  'finance.financialReport.filter.startDate': 'Start Date',
  'finance.financialReport.filter.endDate': 'End Date',
  'finance.financialReport.filter.building': 'Building',
  'finance.financialReport.filter.building.all': 'All Buildings',
  'finance.financialReport.filter.generate': 'Generate Report',
  'finance.financialReport.tab.overview': 'Overview',
  'finance.financialReport.tab.income': 'Income Analysis',
  'finance.financialReport.tab.expense': 'Expense Analysis',
  'finance.financialReport.tab.mortgage': 'Mortgage Repayment',
  'finance.financialReport.tab.parking': 'Parking Repayment',
  'finance.financialReport.tab.budget': 'Budget Request',
  'finance.financialReport.overview.loading':
    'Loading comprehensive statistics...',
  'finance.financialReport.overview.stat.totalIncome': 'Total Income',
  'finance.financialReport.overview.stat.totalIncomeDesc':
    '{count} income entries',
  'finance.financialReport.overview.stat.totalExpense': 'Total Expense',
  'finance.financialReport.overview.stat.totalExpenseDesc':
    '{count} expense entries',
  'finance.financialReport.overview.stat.netCashFlow': 'Net Cash Flow',
  'finance.financialReport.overview.stat.surplusStatus': 'Surplus',
  'finance.financialReport.overview.stat.lossStatus': 'Deficit',
  'finance.financialReport.overview.stat.dimension': 'Dimensions',
  'finance.financialReport.overview.stat.dimensionDesc':
    '{projectCount} projects, {billCount} statements',
  'finance.financialReport.overview.common.unknownProject': 'Unknown Project',
  'finance.financialReport.overview.common.unknownBill': 'Unknown Statement',
  'finance.financialReport.overview.card.projectIncomeExpenseDistribution':
    'Project Income/Expense Distribution',
  'finance.financialReport.overview.card.bankStatementAnalysis':
    'Bank Statement Analysis',
  'finance.financialReport.overview.card.projectIncomeExpenseStatistics':
    'Project Income/Expense Statistics',
  'finance.financialReport.overview.card.bankStatementIncomeExpenseStatistics':
    'Bank Statement Income/Expense Statistics',
  'finance.financialReport.overview.empty.projectData': 'No project data',
  'finance.financialReport.overview.empty.bankStatementData':
    'No bank statement data',
  'finance.financialReport.overview.chart.projectAmountDistribution':
    'Project Amount Distribution',
  'finance.financialReport.overview.table.project.columns.projectName':
    'Project Name',
  'finance.financialReport.overview.table.bank.columns.statementNo':
    'Bank Statement No.',
  'finance.financialReport.overview.table.common.columns.incomeAmount':
    'Income Amount',
  'finance.financialReport.overview.table.common.columns.incomeCount':
    'Income Count',
  'finance.financialReport.overview.table.common.columns.expenseAmount':
    'Expense Amount',
  'finance.financialReport.overview.table.common.columns.expenseCount':
    'Expense Count',
  'finance.financialReport.overview.table.common.columns.netIncome':
    'Net Income',
  'finance.financialReport.overview.table.common.columns.totalCount':
    'Total Count',
  'finance.financialReport.export.title': 'Export Report',
  'finance.financialReport.export.excel': 'Export Excel',
  'finance.financialReport.export.pdf': 'Export PDF',
  'finance.financialReport.export.chart': 'Export Chart',
  'finance.financialReport.export.email': 'Send via Email',
  'finance.financialReport.income.stats.totalIncome': 'Total Income Amount',
  'finance.financialReport.income.stats.approvedCountDesc':
    '{count} approved items in total',
  'finance.financialReport.income.stats.incomeCount': 'Income Item Count',
  'finance.financialReport.income.stats.approvedOnlyDesc':
    '{count} approved items',
  'finance.financialReport.income.stats.completionRate':
    'Approval Completion Rate',
  'finance.financialReport.income.stats.approvedRatioDesc':
    '{approved}/{total} approved',
  'finance.financialReport.income.stats.incomeTypeCount': 'Income Type Count',
  'finance.financialReport.income.stats.incomeTypeCoverDesc':
    'Covering {count} types',
  'finance.financialReport.income.unknownType': 'Unknown Type',
  'finance.financialReport.income.chart.incomeDistribution':
    'Income Distribution',
  'finance.financialReport.income.column.incomeType': 'Income Type',
  'finance.financialReport.income.column.totalAmount': 'Total Amount',
  'finance.financialReport.income.column.totalCount': 'Total Count',
  'finance.financialReport.income.column.pendingAmount': 'Pending Amount',
  'finance.financialReport.income.column.pendingCount': 'Pending Count',
  'finance.financialReport.income.column.approvedAmount': 'Approved Amount',
  'finance.financialReport.income.column.approvedCount': 'Approved Count',
  'finance.financialReport.income.column.completionRate': 'Completion Rate',
  'finance.financialReport.income.loading': 'Loading income statistics...',
  'finance.financialReport.income.empty': 'No income data',
  'finance.financialReport.income.noData': 'No data',
  'finance.financialReport.income.card.distribution':
    'Income Type Distribution',
  'finance.financialReport.income.card.comparison':
    'Income Comparison Analysis',
  'finance.financialReport.income.card.detailStats': 'Income Detail Statistics',
  'finance.financialReport.expense.stats.totalExpense': 'Total Expense Amount',
  'finance.financialReport.expense.stats.approvedCountDesc':
    '{count} approved items in total',
  'finance.financialReport.expense.stats.expenseCount': 'Expense Item Count',
  'finance.financialReport.expense.stats.approvedOnlyDesc':
    '{count} approved items',
  'finance.financialReport.expense.stats.completionRate':
    'Approval Completion Rate',
  'finance.financialReport.expense.stats.approvedRatioDesc':
    '{approved}/{total} approved',
  'finance.financialReport.expense.stats.expenseTypeCount':
    'Expense Type Count',
  'finance.financialReport.expense.stats.expenseTypeCoverDesc':
    'Covering {count} types',
  'finance.financialReport.expense.unknownType': 'Unknown Type',
  'finance.financialReport.expense.chart.expenseDistribution':
    'Expense Distribution',
  'finance.financialReport.expense.column.expenseType': 'Expense Type',
  'finance.financialReport.expense.column.totalAmount': 'Total Amount',
  'finance.financialReport.expense.column.totalCount': 'Total Count',
  'finance.financialReport.expense.column.avgAmount': 'Average Amount',
  'finance.financialReport.expense.column.percentage': 'Percentage',
  'finance.financialReport.expense.column.pendingAmount': 'Pending Amount',
  'finance.financialReport.expense.column.pendingCount': 'Pending Count',
  'finance.financialReport.expense.column.approvedAmount': 'Approved Amount',
  'finance.financialReport.expense.column.approvedCount': 'Approved Count',
  'finance.financialReport.expense.column.completionRate': 'Completion Rate',
  'finance.financialReport.expense.loading': 'Loading expense statistics...',
  'finance.financialReport.expense.empty': 'No expense data',
  'finance.financialReport.expense.noData': 'No data',
  'finance.financialReport.expense.card.distribution':
    'Expense Type Distribution',
  'finance.financialReport.expense.card.comparison':
    'Expense Comparison Analysis',
  'finance.financialReport.expense.card.detailStats':
    'Expense Detail Statistics',
  'finance.financialReport.mortgage.stats.repaidAmount': 'Total Repaid Amount',
  'finance.financialReport.mortgage.stats.completionRateDesc':
    'Completion Rate {rate}%',
  'finance.financialReport.mortgage.stats.pendingAmount':
    'Pending Repayment Amount',
  'finance.financialReport.mortgage.stats.pendingCountDesc':
    '{count} pending repayments',
  'finance.financialReport.mortgage.stats.repaymentCount': 'Repayment Count',
  'finance.financialReport.mortgage.stats.repaidPendingDesc':
    'Repaid {approved}, Pending {pending}',
  'finance.financialReport.mortgage.stats.onTimeRate': 'On-time Repayment Rate',
  'finance.financialReport.mortgage.stats.finishedDesc':
    '{approved}/{total} completed',
  'finance.financialReport.mortgage.unknownBuilding': 'Unknown Building',
  'finance.financialReport.mortgage.unknownType': 'Unknown Type',
  'finance.financialReport.mortgage.type.mortgage': 'Mortgage',
  'finance.financialReport.mortgage.type.rent': 'Rent',
  'finance.financialReport.mortgage.chart.repaymentTypeDistribution':
    'Repayment Type Distribution',
  'finance.financialReport.mortgage.column.building': 'Building',
  'finance.financialReport.mortgage.column.repaymentType': 'Repayment Type',
  'finance.financialReport.mortgage.column.totalAmount': 'Total Amount',
  'finance.financialReport.mortgage.column.totalCount': 'Total Count',
  'finance.financialReport.mortgage.column.pendingAmount': 'Pending Amount',
  'finance.financialReport.mortgage.column.pendingCount': 'Pending Count',
  'finance.financialReport.mortgage.column.repaidAmount': 'Repaid Amount',
  'finance.financialReport.mortgage.column.repaidCount': 'Repaid Count',
  'finance.financialReport.mortgage.column.completionRate': 'Completion Rate',
  'finance.financialReport.mortgage.loading':
    'Loading mortgage repayment statistics...',
  'finance.financialReport.mortgage.empty': 'No mortgage repayment data',
  'finance.financialReport.mortgage.noData': 'No data',
  'finance.financialReport.mortgage.card.typeDistribution':
    'Repayment Type Distribution',
  'finance.financialReport.mortgage.card.buildingComparison':
    'Building Repayment Comparison',
  'finance.financialReport.mortgage.card.detailStats':
    'Mortgage Repayment Detail Statistics',
  'finance.financialReport.parking.stats.repaidAmount': 'Total Repaid Amount',
  'finance.financialReport.parking.stats.completionRateDesc':
    'Completion Rate {rate}%',
  'finance.financialReport.parking.stats.pendingAmount':
    'Pending Repayment Amount',
  'finance.financialReport.parking.stats.pendingCountDesc':
    '{count} pending repayments',
  'finance.financialReport.parking.stats.repaymentCount': 'Repayment Count',
  'finance.financialReport.parking.stats.repaidPendingDesc':
    'Repaid {approved}, Pending {pending}',
  'finance.financialReport.parking.stats.onTimeRate': 'On-time Repayment Rate',
  'finance.financialReport.parking.stats.finishedDesc':
    '{approved}/{total} completed',
  'finance.financialReport.parking.unknownBuilding': 'Unknown Building',
  'finance.financialReport.parking.unknownType': 'Unknown Type',
  'finance.financialReport.parking.type.carLoan': 'Car Loan',
  'finance.financialReport.parking.type.rent': 'Rent',
  'finance.financialReport.parking.chart.repaymentTypeDistribution':
    'Car Loan Repayment Type Distribution',
  'finance.financialReport.parking.column.building': 'Building',
  'finance.financialReport.parking.column.repaymentType': 'Repayment Type',
  'finance.financialReport.parking.column.totalAmount': 'Total Amount',
  'finance.financialReport.parking.column.totalCount': 'Total Count',
  'finance.financialReport.parking.column.avgAmount': 'Average Amount',
  'finance.financialReport.parking.column.pendingAmount': 'Pending Amount',
  'finance.financialReport.parking.column.pendingCount': 'Pending Count',
  'finance.financialReport.parking.column.repaidAmount': 'Repaid Amount',
  'finance.financialReport.parking.column.repaidCount': 'Repaid Count',
  'finance.financialReport.parking.column.completionRate': 'Completion Rate',
  'finance.financialReport.parking.loading':
    'Loading car loan repayment statistics...',
  'finance.financialReport.parking.empty': 'No car loan repayment data',
  'finance.financialReport.parking.noData': 'No data',
  'finance.financialReport.parking.card.typeDistribution':
    'Car Loan Repayment Type Distribution',
  'finance.financialReport.parking.card.buildingComparison':
    'Building Car Loan Repayment Comparison',
  'finance.financialReport.parking.card.detailStats':
    'Car Loan Repayment Detail Statistics',
  'finance.financialReport.budget.stats.totalAppliedAmount':
    'Total Applied Amount',
  'finance.financialReport.budget.stats.totalCountDesc':
    '{count} application items',
  'finance.financialReport.budget.stats.approvedAmount': 'Approved Amount',
  'finance.financialReport.budget.stats.executionRateDesc':
    'Execution Rate {rate}%',
  'finance.financialReport.budget.stats.pendingAmount':
    'Pending Approval Amount',
  'finance.financialReport.budget.stats.pendingCountDesc':
    '{count} pending items',
  'finance.financialReport.budget.stats.rejectedAmount': 'Rejected Amount',
  'finance.financialReport.budget.stats.rejectedCountDesc':
    '{count} rejected items',
  'finance.financialReport.budget.unknownType': 'Unknown Type',
  'finance.financialReport.budget.status.approved': 'Approved',
  'finance.financialReport.budget.status.pending': 'Pending',
  'finance.financialReport.budget.status.rejected': 'Rejected',
  'finance.financialReport.budget.chart.statusDistribution':
    'Budget Request Status Distribution',
  'finance.financialReport.budget.column.budgetType': 'Budget Type',
  'finance.financialReport.budget.column.totalAppliedAmount':
    'Total Applied Amount',
  'finance.financialReport.budget.column.totalCount': 'Application Count',
  'finance.financialReport.budget.column.avgAmount': 'Average Amount',
  'finance.financialReport.budget.column.approvedAmount': 'Approved Amount',
  'finance.financialReport.budget.column.approvedCount': 'Approved Count',
  'finance.financialReport.budget.column.pendingAmount': 'Pending Amount',
  'finance.financialReport.budget.column.pendingCount': 'Pending Count',
  'finance.financialReport.budget.column.rejectedAmount': 'Rejected Amount',
  'finance.financialReport.budget.column.rejectedCount': 'Rejected Count',
  'finance.financialReport.budget.column.approvalRate': 'Approval Rate',
  'finance.financialReport.budget.loading':
    'Loading budget request statistics...',
  'finance.financialReport.budget.empty': 'No budget request data',
  'finance.financialReport.budget.noData': 'No data',
  'finance.financialReport.budget.card.statusDistribution':
    'Budget Request Status Distribution',
  'finance.financialReport.budget.card.typeComparison':
    'Budget Type Comparison Analysis',
  'finance.financialReport.budget.card.detailStatsByType':
    'Budget Request Detail Statistics (Grouped by Type)',
  'finance.pricing_review.action.review': 'Price Review',
};
